export default __webpack_public_path__ + "static/media/1-mobile.ec90e44d.png";